import { parse as parseCookie } from 'cookie';

// eslint-disable-next-line import/prefer-default-export
export function getCookies(req) {
  if (req && req.headers) {
    const cookies = req.headers.cookie;

    if (typeof cookies === 'string') {
      return parseCookie(cookies);
    }
  }

  return {};
}
